export class VerificationSetAdmin {
	autoFill: boolean;
	hidePassword: boolean;
	name: string;
	verificationTypes: VerificationTypeAdmin[];
	paymentValidationTypes: PaymentValidationTypesAdmin[];
}

export class VerificationTypeAdmin {
	id: number;
	superhogVerifiedTypeId: number;
	sortOrder: number;
	name: string;
	provider: string;
	hidden: boolean;
	enabled: boolean;
	required: boolean;
}

export class PaymentValidationTypesAdmin {
	id: number;
	currencyIso: string;
	amount: number;
	fee: number;
	waiver: number | null;
	protection: number | null;
	checkInCoverCost: number | null;
	checkInCoverLimit: number | null;
	reschedule: number | null;
	isFeeRefundable: boolean;
	createdDate: Date;
	disabledValidationOptions: DisabledValidationOptionsEnum;

	constructor(props: { [key in keyof PaymentValidationTypesAdmin]?: PaymentValidationTypesAdmin[key] }) {
		Object.assign(this, {
			...props,
		});
	}
}

export enum DisabledValidationOptionsEnum {
	None = 0,
	Fee = 1,
	Membership = 2,
	FeeWithDeposit = 4,
	Waiver = 8,
	NoCover = 16,
}

export class AccommodationPricePlan {
	id: number;
	name: string;
	editable: boolean;
	createdDate: Date;
	paymentValidationTypes: PaymentValidationTypesAdmin[];

	constructor(props: { [key in keyof AccommodationPricePlan]?: AccommodationPricePlan[key] }) {
		Object.assign(this, {
			paymentValidationTypes: [],
			...props,
		});
	}
}
